import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import MenuItem from './MenuItem';
import matchComponent from '../utils/matchComponent';
import { DropdownNativeContext } from '../Dropdown/context';
var MenuItemGroup = /** @class */ (function (_super) {
    __extends(MenuItemGroup, _super);
    function MenuItemGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMenuItem = matchComponent(MenuItem);
        return _this;
    }
    MenuItemGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, componentClass = _a.componentClass, componentType = _a.componentType, componentProps = _a.componentProps, className = _a.className, label = _a.label, selectedValue = _a.selectedValue, props = __rest(_a, ["children", "componentClass", "componentType", "componentProps", "className", "label", "selectedValue"]);
        // This is necessary to ensure the compiler that the componentClass will not be empty even though it's optional
        var Component = componentClass || MenuItemGroup.defaultProps.componentClass;
        var menuItems = React.Children.toArray(children).filter(function (child) { return React.isValidElement(child) && _this.isMenuItem(child); });
        if (menuItems.length === 0) {
            return null;
        }
        var nonMenuItems = React.Children.toArray(children).filter(function (child) { return !(React.isValidElement(child) && _this.isMenuItem(child)); });
        return (React.createElement(Component, __assign({}, componentProps, { className: className, label: label }),
            this.renderLabel(nonMenuItems),
            this.renderMenuItems(menuItems, props)));
    };
    MenuItemGroup.prototype.renderLabel = function (nonMenuItems) {
        var _this = this;
        if (!this.props.label) {
            return;
        }
        if (nonMenuItems.length > 0) {
            return nonMenuItems;
        }
        return (React.createElement(DropdownNativeContext.Consumer, null, function (isNative) { return (isNative ? null : React.createElement("label", null, _this.props.label)); }));
    };
    MenuItemGroup.prototype.renderMenuItems = function (items, props) {
        var _this = this;
        return React.Children.map(items, function (child) {
            if (!React.isValidElement(child)) {
                return child;
            }
            if (_this.isMenuItem(child)) {
                return React.cloneElement(child, __assign(__assign({}, props), { selected: _this.props.selectedValue !== undefined &&
                        _this.props.selectedValue === child.props.value }));
            }
            return child;
        });
    };
    MenuItemGroup.defaultProps = {
        componentType: MenuItemGroup,
        componentClass: 'div',
    };
    return MenuItemGroup;
}(React.Component));
export default MenuItemGroup;
//# sourceMappingURL=MenuItemGroup.js.map